import { VoiceVisualizer } from 'react-voice-visualizer';
import React, { useEffect, useMemo, useState } from 'react';

export type VoiceVisualizerProps = React.ComponentProps<typeof VoiceVisualizer>;
export type Controls = VoiceVisualizerProps['controls'];

const scaleUint8 = (src: Uint8Array, gain = 2) => {
  const out = new Uint8Array(src.length);
  for (let i = 0; i < src.length; i++) {
    const centered = src[i] - 128; // -128~127
    const scaled = Math.max(-128, Math.min(127, Math.round(centered * gain)));
    out[i] = scaled + 128; // 0~255로 복귀
  }
  return out;
};

const GAIN = 10;

type P = {
  controls: Controls;
  width?: number;
  height?: number;
  speed?: number;
};

const CustomVoiceVisualizer = ({
  controls,
  width = 30,
  height = 20,
  speed = 1,
}: P) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  // react-voice-visualizer 는 controls.audioData 의 '참조'가 바뀔 때마다 파형을 한 칸 전진시켜 그린다.
  // 스케일링한 배열을 controls 객체(RecorderProvider 가 리렌더될 때마다 새 객체) 기준으로 만들면
  // 마우스 이동 등으로 리렌더가 잦아질수록 새 배열이 생겨 파형 속도가 빨라진다 (PORTAL-12802).
  // → 원본 audioData 참조가 바뀔 때만 스케일링해 그리기 횟수를 오디오 프레임에 고정한다.
  const scaledAudioData = useMemo(
    () =>
      controls.audioData
        ? scaleUint8(controls.audioData, GAIN)
        : controls.audioData,
    [controls.audioData],
  );
  const vizControls = useMemo(
    () => ({ ...controls, audioData: scaledAudioData }),
    [controls, scaledAudioData],
  );
  return mounted ? (
    <VoiceVisualizer
      controls={vizControls}
      width={width}
      height={height}
      mainBarColor={'#C77AC4'}
      secondaryBarColor={'#C77AC4'}
      speed={speed}
      rounded={100}
      barWidth={4}
      gap={1}
      fullscreen={true}
      isControlPanelShown={false}
      onlyRecording={true}
      isDefaultUIShown={false}
      animateCurrentPick={true}
      isProgressIndicatorTimeOnHoverShown={false}
      isAudioProcessingTextShown={false}
    />
  ) : (
    <div></div>
  );
};

export default CustomVoiceVisualizer;
